// extracted by mini-css-extract-plugin
export default {"categoryTitle":"profile-interests_categoryTitle__g1M25","form":"profile-interests_form__Qe0Ih"};